
import React from 'react';
import { ProFormSelect, ProFormItem } from '@ant-design/pro-components';
import axiosApiInstance from '../../api/axiosClient';
import { searchParamsAtom } from '../SearchForm';
import { PrimitiveAtom, useAtom } from 'jotai';
import ArtistSelect from '../../CRM/pages/DDEXPage/ArtistSelect';

type OptionType = {
    label: string;
    value: string;
};

interface DynamicSelectProps {
    name: string;
    label: string;
    rules: any[];
    placeholder: string;
    mode?: any;
    endpoint: string; // Dynamic API endpoint
    targetField: string;
    searchAtom?: PrimitiveAtom<any>;
}

export const DynamicSelect: React.FC<DynamicSelectProps> = ({
    name,
    label,
    rules,
    placeholder,
    mode,
    endpoint,
    targetField,
    searchAtom
}) => {
    const defaultAtom = searchAtom || searchParamsAtom;
    const [SearchCriteria, setSearchCriteria] = useAtom(defaultAtom);

    if (targetField === 'artist') {
        return (
            <ProFormItem name={name} label={label} rules={rules}>
                <ArtistSelect
                    mode={mode}
                    placeholder={placeholder}
                    onChange={(value) => {
                        setSearchCriteria((prev: any) => ({
                            ...(prev || {}),
                            [targetField]: value,
                        }));
                    }}
                />
            </ProFormItem>
        );
    }

    return (
        <ProFormItem name={name} rules={rules}>
            <ProFormSelect
                width={300}
                name={name}
                label={label}
                placeholder={placeholder}
                mode={mode}
                showSearch={true}
                request={async () =>
                    axiosApiInstance
                        .get<OptionType[]>(`${endpoint}${new Date().getTime()}`, {
                            params: SearchCriteria
                        })
                        .then(({ data }) => data)
                }
                fieldProps={{
                    showSearch: true,
                    onChange(value) {
                        setSearchCriteria((prev: any) => {
                            return {
                                ...(prev || {}),
                                [targetField]: value
                            };
                        });
                    }
                }}
            />
        </ProFormItem>
    );
};

export default DynamicSelect;
